import { FramerPage } from 'Pages/FramerPage';

const FramerLanding = () => <FramerPage path="" />;

export default FramerLanding;
